export default __webpack_public_path__ + "static/web-development-banner-e15e64171385db28ec581b6b3b065f5c.jpg";